import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Car, Menu, X, LifeBuoy } from "lucide-react";
import { useState } from "react";

const Navbar = () => {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const isAuth = location.pathname === "/signin" || location.pathname === "/signup";
  const isHome = location.pathname === "/";
  const supportHref = "mailto:cancellationsexpress@hotmail.com";

  return (
    <>
      <nav className="sticky top-0 z-50 border-b border-border bg-card/80 backdrop-blur-md">
        <div className="container mx-auto flex h-16 items-center justify-between px-4">
          <Link to="/" className="flex items-center gap-2 font-bold text-xl">
            <div className="relative">
              <Car className="h-7 w-7 text-primary" style={{
                filter: 'drop-shadow(1px 1px 0px hsl(var(--primary-glow)))',
              }} />
              <div className="absolute inset-0 bg-gradient-to-br from-primary via-primary to-[hsl(var(--primary-glow))] opacity-20 rounded" />
            </div>
            <span className="text-foreground font-extrabold tracking-tight">
              Cancellations Express
            </span>
          </Link>

          {/* Desktop */}
          <div className="hidden md:flex items-center gap-4">
            {isHome && (
              <>
                <a href="#how-it-works" className="text-sm text-muted-foreground hover:text-foreground transition-colors">How It Works</a>
                <a href="#pricing" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Pricing</a>
                <a href="#faq" className="text-sm text-muted-foreground hover:text-foreground transition-colors">FAQ</a>
              </>
            )}
            <Button asChild variant="outline" size="sm" className="rounded-full">
              <a href={supportHref}>
                <LifeBuoy className="h-4 w-4 mr-1.5" /> Support
              </a>
            </Button>
            {!isAuth && (
              <>
                <Link to="/signin">
                  <Button variant="ghost">Sign In</Button>
                </Link>
                <Link to="/signup">
                  <Button className="!bg-green-600 hover:!bg-green-700 !text-white">Get Started</Button>
                </Link>
              </>
            )}
          </div>

          {/* Mobile toggle */}
          <button className="md:hidden text-foreground" aria-label="Toggle navigation menu" onClick={() => setMobileOpen(!mobileOpen)}>
            {mobileOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-border bg-card p-4 flex flex-col gap-2">
            {isHome && (
              <>
                <a href="#how-it-works" onClick={() => setMobileOpen(false)} className="py-2 text-sm text-muted-foreground">How It Works</a>
                <a href="#pricing" onClick={() => setMobileOpen(false)} className="py-2 text-sm text-muted-foreground">Pricing</a>
                <a href="#faq" onClick={() => setMobileOpen(false)} className="py-2 text-sm text-muted-foreground">FAQ</a>
              </>
            )}
            <Button asChild variant="outline" className="w-full justify-start rounded-full">
              <a href={supportHref} onClick={() => setMobileOpen(false)}>
                <LifeBuoy className="h-4 w-4 mr-2" /> Support
              </a>
            </Button>
            <Link to="/signin" onClick={() => setMobileOpen(false)}>
              <Button variant="ghost" className="w-full justify-start">Sign In</Button>
            </Link>
            <Link to="/signup" onClick={() => setMobileOpen(false)}>
              <Button className="w-full !bg-green-600 hover:!bg-green-700 !text-white">Get Started</Button>
            </Link>
          </div>
        )}
      </nav>
    </>
  );
};

export default Navbar;
